// extracted by mini-css-extract-plugin
module.exports = {"stack":"BookStack_stack__2WgYA","main":"BookStack_main__1PgI3","heading":"BookStack_heading__x1-hx"};